export const setBackendFieldErrors = (fieldErrors: Record<string, string[]>, setError: any) => {
  Object.entries(fieldErrors).forEach(([key, value]) => {
    setError(key, {
      message: value[0],
      shouldFocus: true,
    });
  });
};
